// import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import moment from 'moment-timezone'

import i18n from '@/lang/'

momentDurationFormatSetup(moment as any)
moment.tz.setDefault(Intl.DateTimeFormat().resolvedOptions().timeZone)

moment.locale(i18n.global.locale.value)

export default moment
